import React, { CSSProperties } from 'react';
import Paper from '@material-ui/core/Paper';
import Typography from '@material-ui/core/Typography';
import { makeStyles, Theme } from '@material-ui/core/styles';

import ActivityCard from './ActivityCard';

const useStyles = makeStyles((theme: Theme) => {
  return {
    activityGroupHeader: {
      background: theme.palette.secondary.main,
      color: 'white',
      textTransform: 'uppercase'
    },
    activityGroupHeaderContainer: {
      borderTopLeftRadius: 4,
      borderTopRightRadius: 4,
      textAlign: 'center',
      padding: theme.spacing(1),
      background: theme.palette.secondary.main
    },
    activitiesContainer: {
      padding: theme.spacing(),
      '& > div:last-child': {
        marginBottom: 0
      }
    },
    activityCard: {
      width: '100%',
      border: '1px solid #EAEAEA',
      marginBottom: theme.spacing(),
      borderRadius: 4
    },
    activityCardImage: {
      width: '100%'
    },
    activityCardActionsContainer: {
      display: 'flex',
      justifyContent: 'space-between',
      borderTop: '1px solid #EAEAEA',
      padding: theme.spacing()
    },
    activityCardAction: {
      display: 'flex',
      alignItems: 'center'
    },
    iconButton: {
      width: 36,
      height: 36,
      minWidth: 'unset',
      padding: 'unset'
    },
    icon: {
      height: 18,
      width: 18
    }
  };
});

export interface ActivityGroupProps {
  title: string;
  activities?: any[];
  subtitleGenerator?: (data: any) => string;
  nameGenerator?: (data: any) => string;
  paperStyle?: CSSProperties;
}

const ActivityGroup: React.FC<ActivityGroupProps> = ({
  title,
  activities = [],
  subtitleGenerator,
  nameGenerator,
  paperStyle
}) => {
  const classes = useStyles();

  return (
    <Paper style={paperStyle}>
      <div className={classes.activityGroupHeaderContainer}>
        <Typography variant="caption" className={classes.activityGroupHeader}>
          {title}
        </Typography>
      </div>
      <div className={classes.activitiesContainer}>
        {activities.map((x, idx) => (
          <ActivityCard
            key={idx}
            name={nameGenerator ? nameGenerator({ ...x, idx }) : ''}
            subtitle={subtitleGenerator ? subtitleGenerator({ ...x, idx }) : ''}
            thumbnail={x.thumbnail}
            videoUrl={x.video}
            url={x.url}
          />
        ))}
      </div>
    </Paper>
  );
};

export default ActivityGroup;
